export const amplitudeEvents = {
  VIEW_TRAVEL_SEARCH_SCREEN: 'VIEW_TRAVEL_SEARCH_SCREEN',
  SELECT_TRAVEL_SEARCH: 'SELECT_TRAVEL_SEARCH',
  VIEW_TRAVEL_RESULTS_SCREEN: 'VIEW_TRAVEL_RESULTS_SCREEN',
  VIEW_TRAVEL_ITEM_DETAIL: 'VIEW_TRAVEL_ITEM_DETAIL',
  SELECT_VIEW_FILTERS: 'SELECT_VIEW_FILTERS',
  ADD_TO_CART: 'ADD_TO_CART',
  TRAVEL_EDIT_PAX: 'TRAVEL_EDIT_PAX',
  PROCEED_TO_CHECKOUT: 'PROCEED_TO_CHECKOUT',
  VIEW_TRAVEL_RESERVATION: 'VIEW_TRAVEL_RESERVATION',
  VIEW_TRAVEL_RESERVATION_DETAIL: 'VIEW_TRAVEL_RESERVATION_DETAIL',
  SELECT_FILTER: 'SELECT_FILTER',
  TRAVEL_SEARCH_ERROR: 'TRAVEL_SEARCH_ERROR',
  TRAVEL_SEAMLESS_ERROR: 'TRAVEL_SEAMLESS_ERROR',
  TRAVEL_BOOKING_ERROR: 'TRAVEL_BOOKING_ERROR',
  VIEW_UPSELL_OPTIONS: 'VIEW_UPSELL_OPTIONS',
  SELECT_UPSELL_OPTIONS: 'SELECT_UPSELL_OPTIONS',
};
